import type { FC } from 'react';

import { cx } from '@emotion/css';
import { RefreshFilled } from '@livechat/design-system-icons';
import { Button, Icon, Text } from '@livechat/design-system-react-components';
import { useSelector } from 'react-redux';

import { CopilotTrackEvent } from 'constants/copilot-event';
import { EventPlace } from 'helpers/analytics';
import { trackEvent } from 'services/event-tracking';
import { getFailedCopilotMessage } from 'store/entities/copilot/selectors';

import { useCopilotMessageContext } from '../CopilotMessageContext';

import * as styles from './styles';

interface IProps {
  eventId: string;
}

export const CopilotErrorEvent: FC<IProps> = ({ eventId }) => {
  const { handleSendMessage } = useCopilotMessageContext();
  const failedCopilotMessage = useSelector(getFailedCopilotMessage);

  const handleRetry = (): void => {
    handleSendMessage(failedCopilotMessage);

    trackEvent(CopilotTrackEvent.ActionPerformed, EventPlace.One, { action: 'retry' });
  };

  return (
    <div className="bubble-wrapper" key={eventId}>
      <div className={styles.eventWrapper(false)}>
        <div className={cx('bubble', styles.bubble)}>
          <div className={styles.errorWrapper}>
            <Text>Sorry, I couldn&apos;t answer your question.</Text>
            <Button onClick={handleRetry} kind="link" icon={<Icon source={RefreshFilled} />} iconPosition="right">
              Retry
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
